<template>
    <div v-if="visible">
      <div class="filter-row">
        <Input v-model="params.keyword" @on-enter="fetchData" placeholder="标段编号/合同编号/合同名称" style="width:240px"/>
        <!-- <Divider type="vertical" />
        <Input v-model="params.contract_number" @on-enter="fetchData" placeholder="合同编号" style="width:120px"/> -->
        <Divider type="vertical" />
        <DatePicker @on-change="projectDateChange" format="yyyy-MM-dd" type="date" placeholder="合同时间" style="width: 120px"></DatePicker>
        <Divider type="vertical" />
        <Select v-model="params.department_id"  @on-change="fetchData" placeholder="选择项目组" style="width:100px">
          <Option value="all" label="All">All</Option>
          <template v-for="(item, ind) in $store.state.department">
            <Option :key="ind" :value="item.value" :label="item.label" v-if="item.value!=56" />
          </template>
        </Select>&nbsp;
        <Button icon="md-search" type="primary" ghost @click="fetchData">筛选</Button>
        <Divider type="vertical" />
        <Button icon="md-download" type="success" ghost @click="exportData">导出</Button>
      </div>
      <Table :columns="columns" :disabled-hover="true" class="contract-table" border ref="ContractTable" :data="counts.data"></Table>
      <div class="pager">
        <Page :total="counts.total" show-sizer :page-size="parseInt(counts.per_page)" :page-size-opts="[10,20,40,60,80,100]" @on-change="pagerChange" @on-page-size-change="pageSizeChange"></Page>
      </div>
      <Drawer title="项目" v-model="projectVisible" width="85">
        <div slot="header">
          项目 
          <Divider type="vertical" />
          <Input style="width:140px" v-model="proParams.project_name" placeholder="项目名称" clearable></Input>
          <Divider type="vertical" />
          <Input style="width:180px" v-model="proParams.keyword" placeholder="订单号" clearable></Input>
          <Divider type="vertical" />
          <DatePicker @on-change="orderDateChange" format="yyyy-MM-dd" type="date" placeholder="订单时间" style="width: 120px"></DatePicker>&nbsp;
          <Button type="success" @click="fetchProject">筛选</Button>
        </div>
        <div v-if="projects.status == 'loading'" style="text-align:center;position: relative;">
          <Spin fix></Spin>
          <div style="padding-top:60px;position:relative;z-index:1000">正在努力获取数据...</div>
          </div>
        <template v-for="(item,ind) in projects.data">
          <Card :key="ind" :title="item.id+'.'+item.project_name" style="margin-bottom:10px">
            <Table :columns="projectsColumns" :disabled-hover="true" :data="item.order"></Table>
            {{item.order[0].children}}
          </Card>
        </template>
      </Drawer>
      <Drawer
        v-model="confirmVisible"
        :width="width">
        <div slot="header">
          <h5><a href="javascript:void(0)" @click="confirmVisible=false"><Icon type="md-arrow-back" size="16" /></a> &nbsp;确认单</h5>
        </div>
      <Row>
        <Col span="10">确认单编号</Col>
        <Col span="8">确认金额</Col>
        <Col span="6">时间</Col>
      </Row>
      <Row v-for="(item, ind) in confirm" :key="ind" class="row-list">
        <Col span="10">{{item.confirm_number}}</Col>
        <Col span="8">¥ {{item.confirm_price}}</Col>
        <Col span="6">{{item.confirm_date}}</Col>
      </Row>
        <div v-if="confirm.length == 0" style="color:#ccc;text-align:center;padding:20px 10px;">-- 暂无开票记录 --</div>
    </Drawer>
    <Drawer
        v-model="invoiceVisible"
        :width="width">
        <div slot="header">
          <h5><a href="javascript:void(0)" @click="invoiceVisible=false"><Icon type="md-arrow-back" size="16" /></a> &nbsp;开票记录</h5>
        </div>
        <Row>
          <Col span="8">确认单编号</Col>
          <Col span="6">开票金额</Col>
          <Col span="6">时间</Col>
          <Col span="4">状态</Col>
        </Row>
        <Row v-for="(item, ind) in invoice" :key="ind" class="row-list">
          <Col span="8">{{item.confirm.confirm_number}}</Col>
          <Col span="6">¥ {{item.price}}</Col>
          <Col span="6">{{item.date}}</Col>
          <Col span="4">{{item.status==0?'已开票':'已到款'}}</Col>
        </Row>
        <div v-if="invoice.length == 0" style="color:#ccc;text-align:center;padding:20px 10px;">-- 暂无开票记录 --</div>
    </Drawer>
    </div>
</template>

<script>
  import {fetch} from '../fetch/api'
  // import projectRow from './ContractProject.vue'
  // import {formatTime} from '../util/filter'

  export default {
    name: 'ContractCount',
    components: {
      // projectRow
      // UploadComponent: resolve => { require(['./UploadComponent'], resolve) }
    },
    props: {
      visible: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        counts: {
          data: []
        },
        projectVisible: false,
        confirmVisible: false,
        invoiceVisible: false,
        width: window.innerWidth <= 640 ? 100 : 640,
        projects: {
          status: 'loading',
          data: []
        },
        confirm: [],
        invoice: [],
        currentTitle: '',
        currentId: '',
        params: {
          department_id: 'all',
          project_date: '',
          order_date: '',
          keyword: '',
          page_size: 15,
          page: 1
        },
        proParams: {
        },
        columns: [
          {
            title: '部门',
            width: 100,
            key: 'department.name',
            render: (h, params) => {
              return h('div', params.row.department.name)
            }
          },
          {
            title: '标段编号',
            width: 200,
            key: 'number'
          },
          {
            title: '合同编号',
            width: 200,
            key: 'contract_number'
          },
          {
            title: '合同名称',
            minWidth: 200,
            key: 'contract_name'
          },
          {
            title: '合同金额',
            width: 120,
            key: 'contract_price'
          },
          {
            title: '合同签订时间',
            width: 130,
            key: 'contract_date'
          },
          {
            title: '状态',
            width: 100,
            key: 'status',
            render: (h, params) => {
              return h('Tag', {props: {color: params.row.status === 0 ? 'blue' : 'default'}}, params.row.status === 0 ? '进行中' : '已完成')
            }
          },
          {
            title: '操作',
            width: 140,
            key: 'status',
            render: (h, params) => {
              return h('Button', {
                props: {
                  size: 'small',
                  icon: 'md-list',
                  type: 'success',
                  long: true
                },
                on: {
                  click: () => {
                    this.currentTitle = params.row.contract_name
                    this.currentId = params.row.id
                    this.projectVisible = true
                    this.projects.status = 'loading'  
                    this.projects.data = []  
                    setTimeout(()=>{
                      this.fetchProject()
                    }, 500)
                  }
                }
              }, '项目('+params.row.projects_count+')')
            }
          }
        ],
        projectsColumns: [
          {
            title: '订单号',
            minWidth: 140,
            key: 'order_number'
          },
          {
            title: '订单金额',
            minWidth: 140,
            key: 'order_price',
            render: (h, params) => {
              return h('span', '¥ '+params.row.order_price||'--')
            }
          },
          {
            title: '已确认金额',
            minWidth: 140,
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  style: {float: 'right', fontSize: '12px'},
                  props: {icon:'md-eye', size: 'small'},
                  on: {
                    click: () => {
                      this.fetchConfirm(params.row.id)
                    }
                  }
                }, '详情'),
                h('span', '¥ ' + (params.row.sum_price ? params.row.sum_price.price : 0))
              ])
            }
          },
          {
            title: '已开票金额',
            minWidth: 140,
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  style: {float: 'right', fontSize: '12px'},
                  props: {icon:'md-eye', size: 'small'},
                  on: {
                    click: () => {
                      this.fetchInvoice(params.row.id)
                    }
                  }
                }, '详情'),
                h('span', '¥ ' + (params.row.sum_invoice_price ? params.row.sum_invoice_price.price : 0))
              ])
            }
          },
          {
            title: '订单时间',
            width: 110,
            render: (h, params) => {
              return h('span', params.row.order_date == 'NaN-aN-aN' ? '未填写' : params.row.order_date)
            }
          },
          {
            title: '更新时间',
            width: 180,
            key: 'updated_at'
          },
        ]
      }
    },
    watch: {
      visible (v) {
        if (v) this.fetchData()
      }
    },
    mounted () {
      if (this.visible) this.fetchData()
    },
    destroyed () {
    },
    methods: {
      pageSizeChange (size) {
        this.params.page_size = size
        this.fetchData()
      },
      pagerChange (page) {
        this.params.page = page
        this.fetchData()
      },
      projectDateChange (date) {
        this.params.contract_date = date
      },
      orderDateChange (date) {
        this.proParams.order_date = date
      },
      fetchProject () {
        this.projects.status = 'loading'
        fetch(`contract/project/${this.currentId}`, {params: this.proParams}).then(res => {
          this.projects.status = 'end'
          this.projects.data = res
        })
      },
      fetchData () {
        fetch(`contract/counts`, {params: this.params}).then(res => {
          // let data = res.data
          // for (const key in data) {
          //   if (data.hasOwnProperty(key)) {
          //     // data[key]['_expanded'] = true
          //   }
          // }
          this.counts = res
        })
      },
      fetchConfirm (id) {
        fetch(`contract/confirm/${id}`).then(res => {
          this.confirm = res
          this.confirmVisible = true
        })
      },
      fetchInvoice (id) {
        fetch(`contract/invoice/${id}`).then(res => {
          this.invoice = res
          this.invoiceVisible = true
        })
      },
      exportData () {
        var dom = document.getElementById('ifile')

        fetch(`contract/export`, {params: this.params}).then(res => {
          if (res.status === 'ok') {
            this.$Modal.success({
              title: '请求成功',
              content: '正在尝试生成excel数据, 请耐心等待...',
              okText: '关闭'
            })
            dom.src = this.apiPath + `contract/export?cry=${res.cry}`
          }
          this.spinShow = false
        }).catch(() => {
          this.spinShow = false
        })
      }
    }
  }
</script>
<style>
  .order_row .ivu-table-cell{display: block;}
  .contract-table .ivu-table-expanded-cell{padding:5px 10px 10px 50px;background-color: #fff}
  /* .contract-table .ivu-table-expanded-cell .ivu-table-wrapper{border-left:none} */
</style>
